<a routerLink="/{{ car.id }}" [ngClass]="{'label': isRanking}">
  <div class="global_photo car_photo" [ngClass]="{'label': (!isRanking && (car.inTransaction || car.sold || car.previousPrice || car.new))}">
    <img src="{{ car.mainPhotoUrl }}?w=600" alt="{{ car.name }}" class="car_image" width="600" height="400" loading="lazy" />
    <span class="car_photo_placeholder"></span>
  </div>
  <div class="car_data">
    <div class="inner_car_data">
      <h3 class="car_name"><span class="model_year" *ngIf="car.modelYear != 0">{{ car.modelYear }}{{ lang | i18nSelect: strings.car.modelYear }}</span>{{ car.name }}</h3>
      <p class="car_copy">{{ car.copy }}</p>
    </div>
    <app-car-price [car]="car" [lang]="lang"></app-car-price>
  </div>
  <div class="next"><img src="assets/img/next.png" width="35" alt=""/></div>
</a>